import { Box, IconButton, Sheet, Stack, Typography } from "@mui/joy";
import { useState } from "react";



// ─── Мульти-календарь ─────────────────────────────────────────────────────────
export default function MultiDateCalendar({ selectedDates, onChange }) {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const [viewYear, setViewYear] = useState(today.getFullYear());
  const [viewMonth, setViewMonth] = useState(today.getMonth());
  const WEEKDAYS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];
  const MONTHS = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
  const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
  const firstDayOfWeek = (new Date(viewYear, viewMonth, 1).getDay() + 6) % 7;
  const toDateStr = (y, m, d) => `${y}-${String(m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  const isSelected = (d) => selectedDates.includes(toDateStr(viewYear, viewMonth, d));
  const isPast = (d) => new Date(viewYear, viewMonth, d) < today;
  const isToday = (d) => viewYear === today.getFullYear() && viewMonth === today.getMonth() && d === today.getDate();
  const isWeekend = (d) => { const day = new Date(viewYear, viewMonth, d).getDay(); return day === 0 || day === 6; };
  const toggleDate = (d) => {
    if (isPast(d)) return;
    const str = toDateStr(viewYear, viewMonth, d);
    onChange(selectedDates.includes(str) ? selectedDates.filter((x) => x !== str) : [...selectedDates, str].sort());
  };
  const prevMonth = () => { if (viewMonth === 0) { setViewMonth(11); setViewYear((y) => y - 1); } else setViewMonth((m) => m - 1); };
  const nextMonth = () => { if (viewMonth === 11) { setViewMonth(0); setViewYear((y) => y + 1); } else setViewMonth((m) => m + 1); };
  const canGoPrev = viewYear > today.getFullYear() || (viewYear === today.getFullYear() && viewMonth > today.getMonth());
  const cells = [];
  for (let i = 0; i < firstDayOfWeek; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <Sheet variant="outlined" sx={{ borderRadius: "16px", overflow: "hidden", userSelect: "none" }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, py: 1.5 }}>
        <IconButton size="sm" variant="plain" disabled={!canGoPrev} onClick={prevMonth} sx={{ borderRadius: "50%" }}>
          <Typography sx={{ fontSize: 18 }}>←</Typography>
        </IconButton>
        <Typography level="title-sm" fontWeight={700}>{MONTHS[viewMonth]} {viewYear}</Typography>
        <IconButton size="sm" variant="plain" onClick={nextMonth} sx={{ borderRadius: "50%" }}>
          <Typography sx={{ fontSize: 18 }}>→</Typography>
        </IconButton>
      </Stack>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", px: 1, pb: 0.5 }}>
        {WEEKDAYS.map((wd, i) => (
          <Typography key={wd} level="body-xs" fontWeight={600} sx={{ textAlign: "center", color: i >= 5 ? "danger.500" : "text.tertiary" }}>{wd}</Typography>
        ))}
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "2px", px: 1, pb: 1.5 }}>
        {cells.map((d, i) => d === null ? <Box key={`e-${i}`} /> : (
          <Box key={d} onClick={() => toggleDate(d)}
            sx={{
              aspectRatio: "1", display: "flex", alignItems: "center", justifyContent: "center",
              borderRadius: "10px", cursor: isPast(d) ? "default" : "pointer", opacity: isPast(d) ? 0.3 : 1,
              fontWeight: isSelected(d) || isToday(d) ? 700 : 400, fontSize: "0.85rem",
              color: isSelected(d) ? "#fff" : isWeekend(d) ? "var(--joy-palette-danger-500)" : "inherit",
              background: isSelected(d) ? "linear-gradient(135deg, #6366f1, #8b5cf6)" : isToday(d) ? "var(--joy-palette-neutral-100)" : "transparent",
              boxShadow: isSelected(d) ? "0 2px 8px rgba(99,102,241,0.35)" : "none", transition: "all 0.15s",
              "&:hover": !isPast(d) && !isSelected(d) ? { background: "var(--joy-palette-primary-50)" } : {},
            }}>{d}</Box>
        ))}
      </Box>
    </Sheet>
  );
}